export default __webpack_public_path__ + "static/media/nfl-logo.e2bd2c9e.png";